import { render } from "./TanaoroshiConfirmDialog.vue?vue&type=template&id=b8cb5286"
import script from "./TanaoroshiConfirmDialog.vue?vue&type=script&lang=js"
export * from "./TanaoroshiConfirmDialog.vue?vue&type=script&lang=js"

import "./TanaoroshiConfirmDialog.vue?vue&type=style&index=0&id=b8cb5286&lang=css"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__